export default "__VITE_ASSET__CPZ3f0s5__"